"use client";
import { FC } from "react";
import { StockNumericType, MoodNumericType } from "data/enums";
import StaySearchForm from "./Stay/StaySearchForm";


export interface HeroSearchFormProps {
  className?: string;
  defaultType: StockNumericType;
  moodType?: MoodNumericType;
  handleSearch: () => void;
}

const HeroSearchForm: FC<HeroSearchFormProps> = ({
  className = "",
  defaultType,
  moodType,
  handleSearch
}) => {

  const renderForm = () => {
    switch (defaultType) {
      case StockNumericType.STAY:
        return <StaySearchForm handleSearch={handleSearch} searchType={StockNumericType.STAY} moodType={moodType}/>;
      case StockNumericType.EXPERIENCE:
        return <StaySearchForm handleSearch={handleSearch} searchType={StockNumericType.EXPERIENCE} moodType={moodType} />;
      case StockNumericType.HOLIDAY_PACKAGE:
        return <StaySearchForm handleSearch={handleSearch} searchType={StockNumericType.HOLIDAY_PACKAGE} moodType={moodType}/>;
      default:
        return <StaySearchForm handleSearch={handleSearch} searchType={defaultType} moodType={moodType}/>;
    }
  };

  return (
    <div
      className={`nc-HeroSearchForm w-full max-w-8xl py-5 lg:py-0 ${className}`}
    >
      {renderForm()}
    </div>
  );
};

export default HeroSearchForm;
